import { createSlice } from "@reduxjs/toolkit";
import { initialDataEditState } from "../config/config.dataExplorer";

export const dataEditSlice = createSlice({
  name: "dataEditor",
  initialState: initialDataEditState,
  reducers: {
    showDatasetForm: (state, action) => {
      state.isDatasetFormVisible = action.payload;
    },
    noteDataChange: (state, action) => {
      state.hasDataChanged = action.payload;
    },
    showAlert: (state, action) => {
      state.isAlertVisible = action.payload;
    },
  },
});
